import {memo} from 'react'

import PropTypes from 'prop-types'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import DealerAds from './dealerAds/index.js'
import DealerRatings from './dealerRatings/index.js'
import SellerInfo from './sellerInfo/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-seller`

const Seller = ({ad, isDealerFavorite, onOpenDrawer, pageName, seller, trackingData, dealerAds, dealerReviews}) => {
  return (
    <div className={BASE_CLASS}>
      <SellerInfo
        ad={ad}
        isDealerFavorite={isDealerFavorite}
        onOpenDrawer={onOpenDrawer}
        seller={seller}
        trackingData={trackingData}
      />

      <DealerRatings
        ad={ad}
        onOpenDrawer={onOpenDrawer}
        pageName={pageName}
        ratings={seller?.dealer?.ratings}
        reviews={dealerReviews}
      />

      <DealerAds dealerAds={dealerAds} seller={seller} />
    </div>
  )
}

Seller.displayName = 'Seller'

Seller.propTypes = {
  ad: PropTypes.shape({
    location: PropTypes.shape({provinceIds: PropTypes.array}),
    provinceId: PropTypes.number
  }),
  isDealerFavorite: PropTypes.bool,
  onOpenDrawer: PropTypes.func.isRequired,
  pageName: PropTypes.string,
  seller: PropTypes.shape({
    dealer: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      location: PropTypes.shape({mapsDirectionsUrl: PropTypes.string, province: PropTypes.string}),
      logoImageUrl: PropTypes.string,
      name: PropTypes.string,
      services: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          isIncluded: PropTypes.bool,
          title: PropTypes.string,
          type: PropTypes.string
        })
      ),
      pack: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ratings: PropTypes.shape({
        average: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        totalReviews: PropTypes.number
      }),
      stockPageUrl: PropTypes.string
    }),
    isDealer: PropTypes.bool,
    user: PropTypes.shape({avatar: PropTypes.string, name: PropTypes.string, province: PropTypes.string})
  }),
  dealerAds: PropTypes.shape({
    items: PropTypes.array,
    totalResults: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  dealerReviews: PropTypes.arrayOf(PropTypes.object),
  trackingData: PropTypes.object
}

export default memo(Seller)
